import { useLocation } from "react-router-dom";
import { Bar, BarLink, BarCta } from "./styles/BottomBar.styles";

const YachtIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 18h16l-2.2 3H6.2L4 18Z" />
    <path d="M5.5 18 5 11l13 4-1 3H5.5Z" />
    <path d="M9 14V4l8 9" />
  </svg>
);

const EnvelopeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3.5 7 8.5 6 8.5-6" />
  </svg>
);

function BottomBar() {
  const location = useLocation();

  return (
    <Bar aria-label="Quick navigation">
      <BarLink to="/yachts" $active={location.pathname.startsWith("/yachts")}>
        <YachtIcon />
        Yachts
      </BarLink>
      <BarCta to="/contact">
        <EnvelopeIcon />
        Enquire
      </BarCta>
    </Bar>
  );
}

export default BottomBar;
